module.exports = __webpack_public_path__ + "img/main_mobile_lotto.e3d3131a.png";